import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  loaderWrapper: {
    position: 'fixed'
  }
});

export default useStyles;
